/** @file entryInverse: the fallback inverse of an entry change, add it back then remove it (plan inverse E). */
import type { FacetEntry } from '@zilo/pose3d-format/types/facet';
import type { Command } from '../types/command';

/**
 * `[facet.addEntry { drawable, entry: <entry now>, index: entry }, facet.removeEntry { drawable, entry: entry + 1 }]`:
 * the old entry goes in first, so an impostor with a single entry never passes through an empty `facets`.
 */
export function entryInverse(drawable: string, index: number, entry: FacetEntry): Command[] {
  return [
    { name: 'facet.addEntry', input: { drawable, entry: structuredClone(entry), index } },
    { name: 'facet.removeEntry', input: { drawable, entry: index + 1 } },
  ];
}
